import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { FormDataService } from 'src/app/enviar-denuncia/services/formData.service';
import { EnviarDenunciaService } from 'src/app/enviar-denuncia/services/enviar-denuncia.service';
import { Denuncia } from 'src/app/enviar-denuncia/models/denuncia';
import { FinalizarDenunciaService } from 'src/app/enviar-denuncia/services/finalizar-denuncia.service';
import { Pin } from 'src/app/enviar-denuncia/models/pin';
import { environment } from 'src/environments/environment.prod';
import { Relacion } from 'src/app/enviar-denuncia/models/relacion copy';
import { Receptor } from 'src/app/enviar-denuncia/models/receptor';
import { Observable } from 'rxjs';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { PasswordComplaint } from 'src/app/shared/models/formData.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { finalize } from 'rxjs/operators';
import { ConsultarDenunciaService } from 'src/app/ver-denuncias/services/consultar-denuncia.service';
import { Abogado } from 'src/app/model/abogado';
@Component({
  selector: 'app-asignar-contrasenia',
  templateUrl: './asignar-contrasenia.component.html',
  styleUrls: ['./asignar-contrasenia.component.css']
})
export class AsignarContraseniaComponent implements OnInit {
  basePath = environment.baseUrl; // O cualquier variable que tengas en environment.ts
  @Input() formData; // Input property to receive form data
  title = 'texto_784';
  passwordForm: FormGroup;
  emailForm: FormGroup;
  passwordVisible = false; // Flag to toggle the visibility of the password field
  repeatedPasswordVisible = false; // Flag to toggle the visibility of the repeated password field
  passwordComplaint: PasswordComplaint; // Object to store the password complaint details
  finalizada: boolean = false;
  isLoading: boolean = false;
  denuncias: Denuncia[];
  isExterna: boolean = false;
  pin: Pin;
  pin_code: string;
  abogados: Abogado[];
  relaciones: Relacion[];
  triaje: string = '';
  finaliza: any = {
    terminos: false,
    proteccionDatos: false
  };
  denuncia: DatosDenuncia[];
  receptor: Receptor[];
  email: boolean = false; // Indicates if the user has provided an email in a previous phase
  hasUpperCase: boolean = false;
  hasLowerCase: boolean = false;
  hasNumber: boolean = false;
  hasSpecialChar: boolean = false;
  hasMinLength: boolean = false;
  isActiveIdPersonalizable: boolean = false; //Is Active Id Custom
  diasinves: string = ''; // investigator's deadline of days
  diasdecisor: string = ''; // deadline of days of the desisor
  diascompliance: string = ''; // deadline of days of compliance
  daysreception: string = ''; // deadline of days of reception
  accessTokenEmail: string = '';
  showModal: boolean = false;

  constructor(
    private apiService: ApiService,
    private consultarDenunciaService: ConsultarDenunciaService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private titleService: Title,
    private formDataService: FormDataService,
    private enviarDenunciaService: EnviarDenunciaService,
    private finalizarDenunciaService: FinalizarDenunciaService
  ) {
    // Set title based on the selected language
    this.translate.get('texto_359').subscribe((text: string) => {
      this.titleService.setTitle(text);
    });

    // Initialize the form group with controls and their validators
    this.passwordForm = this.fb.group({
      passwordComplaint: ['', [
        Validators.minLength(8),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\W_]).+$') // Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character
      ]],
      repeatedPasswordComplaint: ['', [
        Validators.minLength(8),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\W_]).+$') // Must match the same pattern as the first password
      ]],
      email: ['', [
        Validators.pattern('[A-Za-z0-9!@#$%^&*()_+\\-=\\[\\]{};:\'",.<>?/`~]+') //Email password
      ]],
    });

    // Initialize the form group with controls and their validators
    this.emailForm = this.fb.group({
      email: ['', [
        Validators.pattern('[A-Za-z0-9!@#$%^&*()_+\\-=\\[\\]{};:\'",.<>?/`~]+') //Email password
      ]],
    });
  }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (language === "" || language === null) {
      language = 'es'; // Default to Spanish if no language is set
    }

    this.passwordComplaint = this.formDataService.getPasswordComplaint(); // Get password complaint data from the service
    this.formData = this.formDataService.getFormData(); // Retrieve the form data from the service
    if (this.formData?.denuncianteEmail?.trim()) {
      this.email = true; // Set email flag to true if an email is provided in the denunciante form
    }

    // assign deadline days for notifications
    this.diasinves = localStorage.getItem("diasinves");
    this.diasdecisor = localStorage.getItem("diasdecisor");
    this.diascompliance = localStorage.getItem("diascompliance");
    this.daysreception = localStorage.getItem("daysreception");

    this.passwordForm.get('passwordComplaint')?.valueChanges.subscribe((password: string) => {
      this.checkPasswordStrength(password);
    });

    //check if idPersonalizado is active
    if (this.auth.getIdPersonalizable() == '1') {
      this.isActiveIdPersonalizable = true;
    }
  }

  /**
   * Generate an automatic password
   * @param length
   * @returns
   */
  generateAutoPassword(length: number = 12): string {
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const special = '@#%^*()_+-=[]{}|;:,.?';
    const all = upper + lower + numbers + special;

    let password = '';
    password += upper[Math.floor(Math.random() * upper.length)];
    password += lower[Math.floor(Math.random() * lower.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += special[Math.floor(Math.random() * special.length)];

    for (let i = password.length; i < length; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    return password
      .split('')
      .sort(() => Math.random() - 0.5)
      .join('');
  }


  /**
 * Function to validate strength password
 */
  checkPasswordStrength(password: string): void {
    const uppercasePattern = /[A-Z]/;
    const lowercasePattern = /[a-z]/;
    const numberPattern = /\d/;
    const specialCharPattern = /[\W_]/;

    this.hasUpperCase = uppercasePattern.test(password);
    this.hasLowerCase = lowercasePattern.test(password);
    this.hasNumber = numberPattern.test(password);
    this.hasSpecialChar = specialCharPattern.test(password);
    this.hasMinLength = password.length >= 8;
  }

  // Toggle the visibility of the password field
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  // Toggle the visibility of the repeated password field
  toggleRepeatedPasswordVisibility() {
    this.repeatedPasswordVisible = !this.repeatedPasswordVisible;
  }

  showExitAlert() {
    this.showModal = true;
  }

  /**
 * Fuction to save complaint data in form Data service
 * @param form form with complaint data
 * @returns
 */
  save(form: any): boolean {
    const password = this.passwordForm.get('passwordComplaint')?.value; // Get the value of the password field
    const repeatedPassword = this.passwordForm.get('repeatedPasswordComplaint')?.value; // Get the value of the repeated password field
    const emailFromForm = this.passwordForm.get('email')?.value; // Get the value of the email field

    // if there is a manual password, validate
    if (password) {
      if (!form.valid || password !== repeatedPassword) {
        this.toastr.error(this.translate.instant('texto_750'));
        return false;
      }
      this.passwordComplaint.password = password;
    } else {
      // No password entered, generate an automatic one
      const autoPassword = this.generateAutoPassword();
      this.passwordComplaint.password = autoPassword;
    }

    // If an email has been added in the whistleblower data phase, take it, if not, retrieve it from the form.
    if (this.email) {
      this.passwordComplaint.emailRecovery = this.formData?.denuncianteEmail;
    } else {
      this.passwordComplaint.emailRecovery = emailFromForm;
    }

    // Save password and email to recover password in the service
    this.formDataService.setPasswordComplaint(this.passwordComplaint);
    return true;
  }

  /**
   * Save complaint in database
   * Send emails necessary
   * @param form
   */
  crearDenuncia(form: any) {
    this.showModal = false;
    if (this.save(form) && this.finalizada === false) {
      this.isLoading = true;
      this.finalizada = true;
      for (
        var i = 0;
        i < document.getElementsByClassName('grecaptcha-badge').length;
        i++
      ) {
        var div = document.getElementsByClassName('grecaptcha-badge')[i];
        div.setAttribute('style', 'display:none');
      }
      // Navigate to the work page
      this.formData = this.formDataService.getFormData();
      let nombreArchivo = this.formData.nombreArchivo;

      let language = this.auth.getLanguage();
      if (language == '' || language == null) {
        language = 'es';
      }
      this.translate.setDefaultLang(language);
      let generatepin = '';

      this.enviarDenunciaService
        .searchComplaintByUserSocietyID(
          this.formData.empresa,
          this.formData.tipoDenuncia,
          false,
          language
        )
        .subscribe((denuncia: Denuncia[]) => {
          this.denuncias = denuncia;

          if (this.denuncias[0].tipo_gestion == '2') {
            this.isExterna = true;
          }
          let finalizadaDenuncia = (<HTMLInputElement>(
            document.getElementById('finaliced')
          )).value;

          let $clau = false;
          let clausulas_correo = localStorage.getItem('clausulas_correo');
          if (clausulas_correo == '1') {
            $clau = true;
          }
          const testigos = this.formData.testigos.map((testigo) => ({
            nombre_testigo: testigo.firstName,
            apellido_testigo: testigo.lastName,
            email_testigo: testigo.email,
            phone_testigo: testigo.phone,
            descripcion_testigo: testigo.description,
          }));

          if (this.isExterna) {
            this.finalizarDenunciaService
              .createComplaint(
                this.formData.empresa,
                this.formData.idCentro,
                this.formData.tipoDenuncia,
                this.formData.denuncianteFirstName,
                this.formData.denuncianteLastName,
                this.formData.denuncianteDNI,
                this.formData.denuncianteEmail,
                this.formData.denunciantePhone,
                this.formData.fechaDatosDenuncia,
                this.formData.denuncianteRelacion,
                this.formData.descripcionDatosDenuncia,
                '6',
                this.formData.identificadorEmpresa,
                this.formData.comentario,
                nombreArchivo,
                this.formData.receptor,
                this.formData.motivo,
                this.formData.receptorInicial,
                finalizadaDenuncia,
                testigos,
                this.formData.password,
                this.formData.emailRecovery
              ).pipe(
                finalize(() => {
                  this.isLoading = false;
                })
              ).subscribe(
                (pin: Pin) => {
                  this.pin = pin;
                  if (this.pin.pin_code != '0') {
                    this.toastr.success(
                      this.translate.instant('texto_262'),
                      this.translate.instant('texto_263')
                    );
                    this.pin_code = this.pin.pin_code;
                    generatepin = this.makeid(5) + this.pin.id_denuncia + this.makeid(5);
                    this.finalizarDenunciaService
                      .updateParamComplaintById(this.pin.id_denuncia)
                      .subscribe((res) => {
                        if (res == 200) {
                          // Save final password in service
                          this.formDataService.setFinalPassword(
                            this.passwordComplaint.password
                          );
                          //save files in list
                          this.submitFiles(this.pin.id_denuncia);
                          if (this.formData.denuncianteEmail != '') {
                            let url = environment.base + '/ver-denuncia/consultar-denuncia';
                            let idDenunciaMostrado; // Variable to store the complaint ID to be displayed
                            // Check if isActiveIdPersonalizable is true

                            if (this.isActiveIdPersonalizable) {
                              // If true, use identificador_denuncia if it exists, otherwise use id_denuncia

                              idDenunciaMostrado = this.pin.identificador_denuncia
                                ? this.pin.identificador_denuncia
                                : this.pin.id_denuncia;
                            } else {
                              // If isActiveIdPersonalizable is false, only use id_denuncia
                              idDenunciaMostrado = this.pin.id_denuncia;
                            }
                            let message =
                              this.translate.instant('texto_576') +
                              ' ' +
                              this.formData.denuncianteFirstName +
                              ' ' +
                              this.formData.denuncianteLastName +
                              this.translate.instant('texto_604') + " " +
                              idDenunciaMostrado +
                              this.translate.instant('texto_625');

                            this.consultarDenunciaService.loginComplaintByEmail(idDenunciaMostrado, this.formData.password).subscribe({
                              next: (loginResponse: any) => {
                                if (loginResponse?.access_token_email) {

                                  this.accessTokenEmail = loginResponse?.access_token_email;
                                  // Send an email notification to the recipient and the compliance user only if applicable.
                                  this.finalizarDenunciaService
                                    .sendEmailReceptionComplaint(
                                      this.formData.denuncianteEmail,
                                      this.translate.instant('texto_623'),
                                      message,
                                      url,
                                      $clau,
                                      this.translate.instant('texto_624'),
                                      'Denunciante',
                                      loginResponse?.access_token_email,
                                      idDenunciaMostrado
                                    )
                                    .subscribe((res) => {
                                      if (res == 200) {
                                        //this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));

                                      } else {
                                        this.toastr.error(
                                          this.translate.instant('texto_193'),
                                          this.translate.instant('texto_195')
                                        );
                                      }
                                    });

                                  // Method to insert deadline in reception phase
                                  this.insertDeadlinesReception(this.formData.empresa, this.pin.id_denuncia, this.diasinves, this.diasdecisor, this.diascompliance, this.daysreception, 'Recepcion', this.accessTokenEmail);
                                }
                              }
                            })


                            // Method to send email to all the witnesses
                            //this.sendEmailsToWitnesses(testigos, idDenunciaMostrado, $clau);

                          }
                        }
                      });
                    this.finalizarDenunciaService
                      .searchLayerByIdSociety(
                        this.denuncias[0].id_gestor,
                        this.formData.empresa
                      )
                      .subscribe({
                        next: (response) => {
                          if (response.code === 200 && response.success) {
                            this.abogados = response.data || [];
                            let message =
                              this.translate.instant('texto_576') +
                              ' ' +
                              this.abogados[0].n_abogado +
                              this.translate.instant('texto_626');
                            let message2 = this.translate.instant('texto_644');
                            if (this.formData.denuncianteEmail != '') {
                              message2 =
                                message2 +
                                this.translate.instant('texto_627') +
                                this.formData.denuncianteFirstName +
                                ' ' +
                                this.formData.denuncianteLastName +
                                '<br>' +
                                this.translate.instant('texto_628') +
                                this.formData.denuncianteDNI +
                                '<br>' +
                                this.translate.instant('texto_629') +
                                this.formData.denuncianteEmail +
                                '<br>' +
                                this.translate.instant('texto_630') +
                                this.formData.denunciantePhone +
                                '<br>';
                            }
                            let language = this.auth.getLanguage();
                            if (language == '' || language == null) {
                              language = 'es';
                            }
                            this.translate.setDefaultLang(language);
                            let tipoDenuncia = '';
                            this.enviarDenunciaService
                              .searchComplaintByUserSocietyID(
                                this.formData.empresa,
                                this.formData.tipoDenuncia,
                                false,
                                language
                              )
                              .subscribe((denuncia: Denuncia[]) => {
                                this.denuncias = denuncia;
                                tipoDenuncia = denuncia[0].nombre;
                                let tipoRelacion = '';
                                this.finalizarDenunciaService
                                  .searchRelationTypeById(
                                    this.formData.denuncianteRelacion,
                                    this.formData.empresa,
                                    language
                                  )
                                  .subscribe((relacion: Relacion[]) => {
                                    this.relaciones = relacion;
                                    tipoRelacion = relacion[0].nombre;
                                    let message3 =
                                      this.translate.instant('texto_632') +
                                      this.formData.fechaDatosDenuncia.format(
                                        'DD/MM/YYYY'
                                      ) +
                                      '<br>' +
                                      this.translate.instant('texto_633') +
                                      tipoRelacion +
                                      '<br>' +
                                      this.translate.instant('texto_634') +
                                      tipoDenuncia +
                                      '<br>' +
                                      this.translate.instant('texto_635') +
                                      this.formData.descripcionDatosDenuncia +
                                      '<br>' +
                                      this.translate.instant('texto_636') +
                                      this.formData.comentario +
                                      '<br>';

                                    this.consultarDenunciaService.loginComplaintByEmail(this.pin.id_denuncia, this.formData.password).subscribe({
                                      next: (loginResponse: any) => {
                                        if (loginResponse?.access_token_email) {
                                          this.accessTokenEmail = loginResponse?.access_token_email;
                                          // Send an email notification to the recipient and the compliance user only if applicable.
                                          this.finalizarDenunciaService
                                            .sendEmailReceptionComplaint(
                                              this.abogados[0].email,
                                              this.translate.instant('texto_631'),
                                              message +
                                              '<br>' +
                                              message2 +
                                              '<br>' +
                                              message3,
                                              '',
                                              $clau,
                                              this.translate.instant('texto_631'),
                                              'Denunciante',
                                              loginResponse?.access_token_email,
                                              this.pin.id_denuncia
                                            )
                                            .subscribe((res) => {
                                              if (res == 200) {
                                                //this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));
                                              } else {
                                                this.toastr.error(
                                                  this.translate.instant('texto_193'),
                                                  this.translate.instant('texto_195')
                                                );
                                              }
                                            });
                                        }
                                      }
                                    })
                                  });
                              });
                          }
                        }, error: (error) => {
                          this.abogados = [];
                        }
                      });
                    this.redirectGeneratedPin(generatepin);
                  } else {
                    this.toastr.error(
                      this.translate.instant('texto_264'),
                      this.translate.instant('texto_263')
                    );
                    this.formDataService.resetAll();
                    this.router.navigate(["/inicio"]);
                    this.router
                      .navigateByUrl('/RefreshComponent', {
                        skipLocationChange: true,
                      })
                      .then(() => {
                        this.router.navigate(['login']);
                      });
                  }
                },
                (err: any) => {
                  this.toastr.error(
                    this.translate.instant('texto_264'),
                    this.translate.instant('texto_263')
                  );
                }
              );
          } else {
            this.finalizarDenunciaService
              .createComplaint(
                this.formData.empresa,
                this.formData.identificadorCentro,
                this.formData.tipoDenuncia,
                this.formData.denuncianteFirstName,
                this.formData.denuncianteLastName,
                this.formData.denuncianteDNI,
                this.formData.denuncianteEmail,
                this.formData.denunciantePhone,
                this.formData.fechaDatosDenuncia,
                this.formData.denuncianteRelacion,
                this.formData.descripcionDatosDenuncia,
                '0',
                this.formData.identificadorEmpresa,
                this.formData.comentario,
                nombreArchivo,
                this.formData.receptor,
                this.formData.motivo,
                this.formData.receptorInicial,
                finalizadaDenuncia,
                testigos,
                this.formData.password,
                this.formData.emailRecovery
                //this.testigos
              ).pipe(
                finalize(() => {
                  this.isLoading = false;
                })
              ).subscribe(
                (pin: Pin) => {
                  this.pin = pin;
                  if (this.pin.pin_code != '0') {
                    this.toastr.success(
                      this.translate.instant('texto_262'),
                      this.translate.instant('texto_263')
                    );
                    this.pin_code = this.pin.pin_code;
                    generatepin = this.makeid(5) + this.pin.id_denuncia + this.makeid(5);
                    // Save final password in service
                    this.formDataService.setFinalPassword(
                      this.pin_code
                    );
                    //save files in list
                    this.submitFiles(this.pin.id_denuncia);
                    if (this.formData.denuncianteEmail != '') {
                      let url = environment.base + '/ver-denuncia/consultar-denuncia';
                      let idDenunciaMostrado; // Variable to store the complaint ID to be displayed
                      // Check if isActiveIdPersonalizable is true
                      if (this.isActiveIdPersonalizable) {
                        // If true, use identificador_denuncia if it exists, otherwise use id_denuncia
                        idDenunciaMostrado = this.pin.identificador_denuncia
                          ? this.pin.identificador_denuncia
                          : this.pin.id_denuncia;
                      } else {
                        // If isActiveIdPersonalizable is false, only use id_denuncia
                        idDenunciaMostrado = this.pin.id_denuncia;
                      }
                      let message =
                        this.translate.instant('texto_576') +
                        ' ' +
                        this.formData.denuncianteFirstName +
                        ' ' +
                        this.formData.denuncianteLastName +
                        this.translate.instant('texto_637') + " " +
                        this.pin.pin_code + " " +
                        this.translate.instant('texto_645') + " " +
                        idDenunciaMostrado +
                        this.translate.instant('texto_638');

                      this.consultarDenunciaService.loginComplaintByEmail(this.pin.id_denuncia, this.formData.password).subscribe({
                        next: (loginResponse: any) => {
                          if (loginResponse?.access_token_email) {
                            this.accessTokenEmail = loginResponse?.access_token_email;

                            // Send an email notification to the recipient and the compliance user only if applicable.
                            this.finalizarDenunciaService
                              .sendEmailReceptionComplaint(
                                this.formData.denuncianteEmail,
                                this.translate.instant('texto_623'),
                                message,
                                url,
                                $clau,
                                this.translate.instant('texto_624'),
                                'Denunciante',
                                loginResponse?.access_token_email,
                                this.pin.id_denuncia
                              )
                              .subscribe((res) => {
                                if (res == 200) {
                                  this.finalizarDenunciaService
                                    .searchComplaintByPin(this.pin.id_denuncia, language)
                                    .subscribe({
                                      next: (denuncia) => {
                                        if (denuncia.code === 200 && denuncia.success) {
                                          this.denuncia = denuncia.data;
                                          let url2 =
                                            environment.base +
                                            '/editar-denuncia/' +
                                            this.denuncia[0].id_denuncia;
                                          this.finalizarDenunciaService
                                            .searchReceptorByIdComplaint(
                                              this.denuncia[0].id_denuncia,
                                              true
                                            )
                                            .subscribe({
                                              next: (receptor) => {
                                                if (receptor.code === 200 && receptor.success) {
                                                  this.receptor = receptor.data;
                                                  let idDenunciaMostradoReceptor; // Variable to store the complaint ID to be displayed
                                                  // Check if isActiveIdPersonalizable is true
                                                  if (this.isActiveIdPersonalizable) {
                                                    // If true, use identificador_denuncia if it exists, otherwise use id_denuncia
                                                    idDenunciaMostradoReceptor = this.pin.identificador_denuncia
                                                      ? this.pin.identificador_denuncia
                                                      : this.pin.id_denuncia;
                                                  } else {
                                                    // If isActiveIdPersonalizable is false, only use id_denuncia
                                                    idDenunciaMostradoReceptor = this.pin.id_denuncia;
                                                  }
                                                  let messageReceptor =
                                                    this.translate.instant('texto_576') +
                                                    ' ' +
                                                    this.receptor[0].id_user + " " +
                                                    this.translate.instant('texto_639') + " " +
                                                    idDenunciaMostradoReceptor +
                                                    this.translate.instant('texto_640');
                                                  let asunto =
                                                    this.translate.instant('texto_641');
                                                  if (this.triaje == '1') {
                                                    asunto =
                                                      this.translate.instant('texto_642');
                                                  }


                                                  this.consultarDenunciaService.loginComplaintByEmail(this.pin.id_denuncia, this.formData.password).subscribe({
                                                    next: (loginResponse: any) => {
                                                      if (loginResponse?.access_token_email) {
                                                        this.accessTokenEmail = loginResponse?.access_token_email

                                                        // Send an email notification to the recipient and the compliance user only if applicable.
                                                        this.finalizarDenunciaService
                                                          .sendEmailReceptionComplaint(
                                                            this.receptor[0].mail_user,
                                                            asunto,
                                                            messageReceptor,
                                                            url2,
                                                            $clau,
                                                            asunto,
                                                            'Denunciante',
                                                            loginResponse?.access_token_email,
                                                            this.pin.id_denuncia
                                                          )
                                                          .subscribe((res) => {
                                                            if (res == 200) {
                                                              //this.toastr.success(this.translate.instant('texto_194'), this.translate.instant('texto_195'));
                                                            } else {
                                                              this.toastr.error(
                                                                this.translate.instant('texto_193'),
                                                                this.translate.instant('texto_195')
                                                              );
                                                            }
                                                          });

                                                        // Method to insert deadline in reception phase
                                                        this.insertDeadlinesReception(this.formData.empresa, this.pin.id_denuncia, this.diasinves, this.diasdecisor, this.diascompliance, this.daysreception, this.receptor[0].mail_user, this.accessTokenEmail);
                                                      }
                                                    }
                                                  })
                                                }
                                              }, error: (err) => {
                                                this.toastr.error(this.translate.instant('texto_916'), this.translate.instant('texto_813'));
                                              }
                                            });
                                        }
                                      },
                                      error: (err) => {
                                        this.toastr.error(this.translate.instant('texto_900'), this.translate.instant('texto_902'));
                                      }
                                    });
                                } else {
                                  this.toastr.error(
                                    this.translate.instant('texto_193'),
                                    this.translate.instant('texto_195')
                                  );
                                }
                              });
                          }
                        }
                      })

                      // Method to send email to all the witnesses
                      // this.sendEmailsToWitnesses(testigos, idDenunciaMostrado, $clau);

                    } else {
                      let language = this.auth.getLanguage();
                      if (language == '' || language == null) {
                        language = 'es';
                      }
                      this.finalizarDenunciaService

                        .searchComplaintByPin(this.pin.id_denuncia, language)
                        .subscribe({
                          next: (denuncia) => {
                            if (denuncia.code === 200 && denuncia.success) {
                              this.denuncia = denuncia.data;
                              this.finalizarDenunciaService
                                .searchReceptorByIdComplaint(
                                  this.denuncia[0].id_denuncia,
                                  true
                                )
                                .subscribe({
                                  next: (receptor) => {
                                    if (receptor.code === 200 && receptor.success) {
                                      this.receptor = receptor.data;
                                      let url2 =
                                        environment.base +
                                        '/editar-denuncia/' +
                                        this.denuncia[0].id_denuncia;
                                      let asunto = this.translate.instant('texto_641');
                                      if (this.triaje == '1') {
                                        asunto = this.translate.instant('texto_642');
                                      }
                                      let idDenunciaMostradoReceptor; // Variable to store the complaint ID to be displayed
                                      // Check if isActiveIdPersonalizable is true
                                      if (this.isActiveIdPersonalizable) {
                                        // If true, use identificador_denuncia if it exists, otherwise use id_denuncia
                                        idDenunciaMostradoReceptor = this.pin.identificador_denuncia
                                          ? this.denuncia[0].identificador_denuncia
                                          : this.denuncia[0].id_denuncia;
                                      } else {
                                        // If isActiveIdPersonalizable is false, only use id_denuncia
                                        idDenunciaMostradoReceptor = this.denuncia[0].id_denuncia;
                                      }
                                      let messageReceptor =
                                        this.translate.instant('texto_576') +
                                        ' ' +
                                        this.receptor[0].id_user +
                                        this.translate.instant('texto_646') + " " +
                                        idDenunciaMostradoReceptor +
                                        this.translate.instant('texto_643');

                                      this.consultarDenunciaService.loginComplaintByEmail(this.pin.id_denuncia, this.formData.password).subscribe({
                                        next: (loginResponse: any) => {
                                          if (loginResponse?.access_token_email) {
                                            this.accessTokenEmail = loginResponse?.access_token_email;
                                            // Send an email notification to the recipient and the compliance user only if applicable.
                                            this.finalizarDenunciaService
                                              .sendEmailReceptionComplaint(
                                                this.receptor[0].mail_user,
                                                asunto,
                                                messageReceptor,
                                                url2,
                                                $clau,
                                                asunto,
                                                'Denunciante',
                                                loginResponse?.access_token_email,
                                                this.pin.id_denuncia
                                              )
                                              .subscribe((res) => {
                                                if (res == 200) {

                                                } else {
                                                  this.toastr.error(
                                                    this.translate.instant('texto_193'),
                                                    this.translate.instant('texto_195')
                                                  );
                                                }
                                              });

                                            // Method to insert deadline in reception phase
                                            this.insertDeadlinesReception(this.formData.empresa, this.pin.id_denuncia, this.diasinves, this.diasdecisor, this.diascompliance, this.daysreception, this.receptor[0].mail_user, this.accessTokenEmail);
                                          }
                                        }
                                      })
                                      // Method to send email to all the witnesses
                                      //this.sendEmailsToWitnesses(testigos, idDenunciaMostradoReceptor, $clau);
                                    }
                                  }, error: (err) => {
                                    this.toastr.error(this.translate.instant('texto_916'), this.translate.instant('texto_813'));
                                  }
                                });
                            }
                          },
                          error: (err) => {
                            this.toastr.error(this.translate.instant('texto_900'), this.translate.instant('texto_902'));
                          }
                        });
                    }

                    this.redirectGeneratedPin(generatepin);

                  } else {
                    this.toastr.error(
                      this.translate.instant('texto_264'),
                      this.translate.instant('texto_263')
                    );
                    this.formDataService.resetAll();
                    this.router.navigate(["/inicio"]);
                    this.router
                      .navigateByUrl('/RefreshComponent', {
                        skipLocationChange: true,
                      })
                      .then(() => {
                        this.router.navigate(['login']);
                      });
                  }
                },
                (err: any) => {
                  this.toastr.error(
                    this.translate.instant('texto_264'),
                    this.translate.instant('texto_263')
                  );
                }
              );
          }
          // this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          //   this.router.navigate(['finalizada/', generatepin]);
          // });
        });
    }
  }

  /**
   * redirect a generated pin to the final screen
   * @param generatepin // pin generated
   */
  redirectGeneratedPin(generatepin) {
    this.formDataService.resetAll();
    this.router
      .navigateByUrl('/RefreshComponent', { skipLocationChange: true, })
      .then(() => { this.router.navigate(['/enviar-denuncia/finalizada/', generatepin,]); });
  }

  /*
  * Sends emails to witnesses to notify about the complaint
  * Parameters
  *   testigos: An array of witness objects.
  *   idComplaint: The ID of the complaint to be displayed.
  *   $clau: A parameter used in the email sending process.
  */
  /*sendEmailsToWitnesses(witnesses, idComplaint, $clau) {
    // Check if there are witnesses in the array
    if (witnesses && witnesses.length > 0) {
      // Loop through each witness in the array
      witnesses.forEach((witness) => {
        // Check if the witness has an email address
        if (witness.email_testigo) {
          // Build and send the email
          let message = `${this.translate.instant('texto_576')} ${witness.nombre_testigo} ${witness.apellido_testigo}, ${this.translate.instant('texto_805')} ${idComplaint}. ${this.translate.instant('texto_806')}. <br>Comentarios: ${witness.descripcion_testigo}`;
          this.finalizarDenunciaService
            .sendEmail(
              witness.email_testigo,
              this.translate.instant('texto_807'),
              message,
              '',
              $clau,
              this.translate.instant('texto_808')
            )
            .subscribe((res) => {
              if (res == 200) {
                // this.toastr.success(
                //   this.translate.instant('texto_194'),
                //   this.translate.instant('texto_195')
                // );
              } else {
                // this.toastr.error(
                //   this.translate.instant('texto_193'),
                //   this.translate.instant('texto_195')
                // );
              }
            });
        }
      });
    }
  }*/

  insertDeadlinesReception(id_sociedad, id_denuncia, plazo_investigacion, plazo_decisor, plazo_compliance, plazo_recepcion, id_usuario, token) {
    this.apiService.createDeadlinesByIdComplaintInit(id_sociedad, id_denuncia, '0', '0', '0', plazo_recepcion, id_usuario, token).subscribe(
      res => {
        if (res == 200) {
          return true;
        }
      })
  }

  submitFiles(id_denuncia) {
    //get files list
    let archivos = this.formDataService.getArchivos();
    if (archivos.length > 0) {
      archivos.forEach(archivo => {
        const formData = new FormData();
        //set data to formData
        formData.append('file', archivo.nombreArchivo);
        formData.append('id_sociedad', this.formDataService.getTipoHecho().empresa);
        formData.append('id_denuncia', id_denuncia);
        formData.append('comentario', archivo.descripcionArchivo);
        formData.append('id_usuario', 'Denunciante');
        formData.append('role', '');
        //send to the UploadFile service the parameter fomData
        this.finalizarDenunciaService.uploadFile(formData).subscribe(
          (res: any) => {
            if (res?.message) {
              this.toastr.success(this.translate.instant('texto_202'), this.translate.instant('texto_203'));
            } else {
              this.toastr.error(this.translate.instant('texto_204'), this.translate.instant('texto_203'));
            }
          },
          (err) => {
            this.toastr.error(this.translate.instant('texto_204') + ". " + err.error.error, this.translate.instant('texto_813'));
          }
        );
      });
    }

  }

  hide() {
    this.formDataService.resetAll();
    this.router.navigate(['/inicio']);
  }

  private makeid(length) {
    var result = '';
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
